import { inject, Service, signal } from "@angular/core";
import { filter, tap } from "rxjs";

import type { PillarPerformanceModelType } from "../models";
import { CalculationEngineApiService } from "./calculation-engine-api-service";

@Service()
export class PillarEkpiPerformanceService {
  private readonly _calculationEngineApiService = inject(CalculationEngineApiService);

  ekpiPillarPerformance = signal<PillarPerformanceModelType[]>([]);

  public getData(periodId: number, isQuarter: boolean, entityId: number) {
    return this._calculationEngineApiService.getPillarPerformance(periodId, entityId, isQuarter).pipe(
      filter((res) => !res.inError),
      tap({
        next: (res) => {
          if (res.inError) return;
          this.ekpiPillarPerformance.update(() => res.responseData);
        },
      })
    );
  }
}
